module.exports = __webpack_public_path__ + "static/media/atom-alt.e10f8d1a.svg";